import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import "modules/PrivacyAndSecurityDashboard/components/Agreements/Agreements.scss";
import { formatDate } from "utils/dateHelperFunctions";

import type { AgreementHistory } from "models";

type AgreementsProps = {
  agreementsHistory?: AgreementHistory[];
};

export const Agreements = ({ agreementsHistory }: AgreementsProps) => {
  const { t } = useTranslation();

  if (!agreementsHistory?.length) return null;

  return (
    <div className="Agreements">
      <div className="Agreements__title">{t("v8_accepted_agreements", "Accepted agreements")}</div>
      {agreementsHistory.map(agreement => (
        <div className="Agreements__row" key={agreement.id}>
          <div>
            {formatDate(agreement.created_on, DATE_FORMATS_FNS.monthDayYear)} <Icon className="circle" />
          </div>
          {agreement.user && (
            <div>
              {`${agreement.user.first_name || ""} ${agreement.user.last_name}`} <Icon className="circle" /> {agreement.user.email} <Icon className="circle" />
            </div>
          )}
          <div>{agreement.agreement_version_id}</div>
        </div>
      ))}
    </div>
  );
};
